import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ALLOWANCE } from '../../constants/defaults';
import AllowanceChargeFieldRow from './AllowanceChargeFieldRow';

const AllowanceChargeSection = ({
  title,
  type,
  fields,
  onAdd,
  onEdit,
  onDelete,
  readOnly = false,
  isDocumentLevel = false,
}) => {
  const isAllowance = type === ALLOWANCE;
  const buttonText = isAllowance ? 'Add Allowance' : 'Add Charge';
  const emptyStateText = isAllowance ? 'allowances' : 'charges';
  return (
    <Box sx={{ mb: 3 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="subtitle1" color="text.secondary" fontWeight={500}>
          {title}
        </Typography>
        <Button variant="outlined" startIcon={<AddIcon />} onClick={onAdd} disabled={readOnly}>
          {buttonText}
        </Button>
      </Stack>

      {fields.length > 0 ? (
        <Stack spacing={1}>
          {fields.map((item, index) => (
            <AllowanceChargeFieldRow
              key={item.id}
              item={item}
              index={index}
              type={type}
              isDocumentLevel={isDocumentLevel}
              onEdit={onEdit}
              onDelete={onDelete}
              readOnly={readOnly}
            />
          ))}
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
          No {emptyStateText} added yet
        </Typography>
      )}
    </Box>
  );
};

export default AllowanceChargeSection;
